export default class Navigation {
    constructor() {

        let hero = document.querySelector('.hero');
        let menubar = document.querySelector('.menubar');
        let menubarHeight = menubar.offsetHeight;

        const narrowMenu = () => {
            menubar.classList.add('menubar--narrow');
            const allLinks = menubar.querySelectorAll('.nav-main__link');
            const allDropdown = menubar.querySelectorAll('.nav-main__dropdown');
    
            if (allLinks) {
                allLinks.forEach(link => {
                    link.classList.add('nav-main__link--brand');
                });
            }
            if (allDropdown) {
                allDropdown.forEach(drop => {
                    drop.classList.add('nav-main__dropdown--brand')
                });
            }
        }

        const enlargeMenu = () => {
            menubar.classList.remove('menubar--narrow');
            const allLinksBrand = menubar.querySelectorAll('nav-main__link--brand');
            const allDropdownBrand = menubar.querySelectorAll('nav-main__dropdown--brand');
    
            if (allLinksBrand) {
                allLinksBrand.forEach(link => {
                    link.classList.remove('nav-main__link--brand');
                });
            }
            if (allDropdownBrand) {
                allDropdownBrand.forEach(drop => {
                    drop.classList.remove('nav-main__dropdown--brand')
                });
            }
        }

        // HERO CHECK
        if (hero) {
            let heroHeight = hero.offsetHeight;
            let heroOffset = hero.offsetTop;

            let heroEnd = heroHeight + heroOffset;
            let menuBreakpoint = heroEnd - menubarHeight;

            let currentScrollPos = document.documentElement.scrollTop

            if (currentScrollPos > menuBreakpoint)
                narrowMenu();
            else
                enlargeMenu();

            window.onscroll = (event) => {
                currentScrollPos = document.documentElement.scrollTop;

                if (currentScrollPos > menuBreakpoint)
                    narrowMenu();
                else
                    enlargeMenu();
            };
        } else {
            narrowMenu();
        }

        document.querySelector('.js--hamburger').addEventListener('click', () => {
            let mobileMenu = document.querySelector('.mobile-menu');
            mobileMenu.classList.toggle('is--open');
            if (mobileMenu.classList.contains('is--open')) {
                document.querySelector('.hamburger__icon').classList.add('is--open');
                document.querySelector('body, html').classList.add('overflow--hidden');
            } else {
                document.querySelector('.hamburger__icon').classList.remove('is--open');
                document.querySelector('body, html').classList.remove('overflow--hidden');
            }
        });

        document.querySelector('.mobile-menu-items__link').addEventListener('click', (e) => {
            e.preventDefault();
            let id = document.querySelector(this).closest('.mobile-menu-item').data('id');
            if (id) {
                document.querySelector('#mobile-item-' + id).classList.add('is--open');
            }
        });

        document.querySelector('.js--close-second').addEventListener('click', () => {
            document.querySelector(this).closest('.mobile-menu-second').classList.remove('is--open');
        });
    }
}
